(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/pages/bankid/bankid-poll.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/pages/bankid/bankid-poll.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const UpdateHeader = svs.playerLoginReact.sharedComponents.UpdateHeader;
const _svs$playerLoginReact = svs.playerLoginReact.bankid.components,
  BankIdStart = _svs$playerLoginReact.BankIdStart,
  BankIdWaiting = _svs$playerLoginReact.BankIdWaiting;
const _svs$playerLoginReact2 = svs.playerLoginReact.constants,
  bankIdPollType = _svs$playerLoginReact2.bankIdPollType,
  appWaitStatus = _svs$playerLoginReact2.appWaitStatus;
const BankIdPoll = _ref => {
  let _ref$isLogin = _ref.isLogin,
    isLogin = _ref$isLogin === void 0 ? true : _ref$isLogin,
    _ref$pollState = _ref.pollState,
    pollState = _ref$pollState === void 0 ? bankIdPollType.BEFORE_POLL : _ref$pollState,
    _ref$bankIdPollWait = _ref.bankIdPollWait,
    bankIdPollWait = _ref$bankIdPollWait === void 0 ? appWaitStatus.WAITING_QRCODE : _ref$bankIdPollWait;
  const _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    preFetchedAst = _React$useState2[0],
    setPreFetchedAst = _React$useState2[1];
  const _React$useState3 = React.useState(pollState),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    localPollState = _React$useState4[0],
    setLocalPollState = _React$useState4[1];
  const _React$useState5 = React.useState(bankIdPollWait),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    localBankIdPollWait = _React$useState6[0],
    setLocalBankIdPollWait = _React$useState6[1];
  React.useEffect(() => {
    UpdateHeader.updateHeader(isLogin ? 'Logga in' : 'Bli kund');
  }, [isLogin]);
  React.useEffect(() => {
    if (preFetchedAst) {
      setLocalBankIdPollWait(appWaitStatus.WAITING_APP);
      setLocalPollState(bankIdPollType.WAITING_POLL);
    }
  }, [preFetchedAst]);
  return React.createElement(React.Fragment, null, localPollState === bankIdPollType.BEFORE_POLL && React.createElement(BankIdStart, {
    isLogin: isLogin,
    setPreFetchedAst: setPreFetchedAst,
    pollState: localPollState
  }), localPollState === bankIdPollType.WAITING_POLL && React.createElement(BankIdWaiting, {
    isLogin: isLogin,
    bankIdPollWait: localBankIdPollWait,
    preFetchedAst: preFetchedAst,
    setPreFetchedAst: setPreFetchedAst
  }));
};
svs.playerLoginReact.bankid.BankIdPoll = BankIdPoll;

 })(window);